import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import useExchangeToken from '../../hooks/useExchangeToken';
import { getWipMaster } from '../../services/wipTrackingApi';
import StandardSettingList from '../../components/setting/StandardSettingList';
import MonitorNavigation from '../../components/monitor/MonitorNavigation';
import AddIcon from '@mui/icons-material/Add';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

export default function WipMasterList() {
  const { plant, factory } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const exchangeToken = useExchangeToken();
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const base = location.pathname.replace(/\/$/, '');
  useEffect(() => {
    let active = true;
    setLoading(true);
    exchangeToken().then(token => getWipMaster({ plant_id: plant, factory }, token))
      .then(response => { if (active) setRows(Array.isArray(response.data) ? response.data : response.data.results || []); })
      .catch(() => { if (active) setError('โหลด Master ไม่สำเร็จ กรุณาลองใหม่'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [plant, factory, exchangeToken]);
  return <Box sx={{ p: { xs: 1.5, md: 2 }, minWidth: 0, bgcolor: '#def6f3' }}>
    <MonitorNavigation />
    <Box sx={{ bgcolor: '#fff', borderRadius: 2, p: 2, mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Inventory2OutlinedIcon sx={{ color: '#00B3BD', fontSize: 32 }} />
        <Box>
          <Typography component="h1" sx={{ fontSize: 24, fontWeight: 600, color: '#008b93' }}>WIP Master</Typography>
          <Typography sx={{ fontSize: 18, color: 'text.secondary', overflowWrap: 'anywhere' }}>Plant {plant} · Factory {factory}</Typography>
        </Box>
      </Box>
      <Button variant="contained" startIcon={<AddIcon />} sx={{ minHeight: 44, fontSize: 18, bgcolor: '#00B3BD', boxShadow: 'none', '&:hover': { bgcolor: '#009da6' } }} onClick={() => navigate(`${base}/new${location.search}`)}>เพิ่ม Master</Button>
    </Box>
    {error && <Alert severity="error">{error}</Alert>}
    {loading ? <Box sx={{ p: 4, textAlign: 'center', bgcolor: '#fff', borderRadius: 2 }}><CircularProgress aria-label="กำลังโหลด Master" /></Box> : <StandardSettingList customers={rows} isWipPlant editBase={`${base}/edit`} />}
  </Box>;
}
